import { render, staticRenderFns } from "./MarketplaceLogTable.vue?vue&type=template&id=2c3de86a&scoped=true&"
import script from "./MarketplaceLogTable.vue?vue&type=script&lang=js&"
export * from "./MarketplaceLogTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceLogTable.vue?vue&type=style&index=0&id=2c3de86a&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3de86a",
  null
  
)

export default component.exports